(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.essentia-whatsapp-buy');
    if (!link) return;

    const wrapper = link.closest('.buy-buttons-block');
    const variantDataElement = wrapper?.querySelector('.essentia-whatsapp-variant-data');
    if (!variantDataElement) return;

    let variantData;
    let optionNames;
    try {
      variantData = JSON.parse(variantDataElement.textContent || '{}');
      optionNames = JSON.parse(variantDataElement.dataset.optionNames || '[]');
    } catch (error) {
      event.preventDefault();
      return;
    }

    const picker = link.closest('.product-details')?.querySelector('variant-picker[data-template-product-match="true"]');
    const selectedOptions = new Map();
    if (picker) {
      picker.querySelectorAll('input[type="radio"][data-option-name]:checked').forEach((input) => {
        selectedOptions.set(input.dataset.optionName, input.value);
      });
      picker.querySelectorAll('select[name^="options["]').forEach((select) => {
        const optionName = select.selectedOptions[0]?.dataset.optionName || select.name.replace(/^options\[|\]$/g, '');
        if (optionName) selectedOptions.set(optionName, select.value);
      });
    }

    const matches = Object.entries(variantData).filter(([, value]) => {
      if (!Array.isArray(value.options) || !Array.isArray(optionNames)) return false;
      return optionNames.every((optionName, index) =>
        !selectedOptions.has(optionName) || value.options[index] === selectedOptions.get(optionName)
      );
    });

    const hiddenId = wrapper?.querySelector('input[name="id"]')?.value || '';
    let variantId = '';
    if (selectedOptions.size > 0) {
      if (matches.length === 1) {
        variantId = matches[0][0];
      } else if (matches.length > 1 && matches.some(([id]) => id === hiddenId)) {
        variantId = hiddenId;
      }
    } else if (variantData[hiddenId]) {
      variantId = hiddenId;
    } else if (Object.keys(variantData).length === 1) {
      variantId = Object.keys(variantData)[0];
    }

    if (!variantId || !variantData[variantId]) {
      event.preventDefault();
      console.warn('ESSENTIA WhatsApp: la variante seleccionada aún no se pudo resolver.');
      return;
    }

    const variant = variantData[variantId];
    const productUrl = new URL(link.dataset.productUrl || window.location.pathname, window.location.origin);
    productUrl.searchParams.set('variant', variantId);
    const lines = [
      'Hola, necesito ayuda con este producto en ESSENTIA.',
      '',
      'Producto: ' + (link.dataset.productTitle || ''),
      'Presentación: ' + (variant.title || ''),
      'Precio: ' + (variant.price || ''),
      '',
      'Enlace: ' + productUrl.toString(),
      '',
      '¿Me ayudan a finalizar la compra?'
    ];
    link.href = 'https://wa.me/595991692682?text=' + encodeURIComponent(lines.join('\n'));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["essentia-cro-buy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.essentia-whatsapp-buy');
    if (!link) return;

    const wrapper = link.closest('.buy-buttons-block');
    const variantDataElement = wrapper?.querySelector('.essentia-whatsapp-variant-data');
    if (!variantDataElement) return;

    let variantData;
    let optionNames;
    try {
      variantData = JSON.parse(variantDataElement.textContent || '{}');
      optionNames = JSON.parse(variantDataElement.dataset.optionNames || '[]');
    } catch (error) {
      event.preventDefault();
      return;
    }

    const picker = link.closest('.product-details')?.querySelector('variant-picker[data-template-product-match="true"]');
    const selectedOptions = new Map();
    if (picker) {
      picker.querySelectorAll('input[type="radio"][data-option-name]:checked').forEach((input) => {
        selectedOptions.set(input.dataset.optionName, input.value);
      });
      picker.querySelectorAll('select[name^="options["]').forEach((select) => {
        const optionName = select.selectedOptions[0]?.dataset.optionName || select.name.replace(/^options\[|\]$/g, '');
        if (optionName) selectedOptions.set(optionName, select.value);
      });
    }

    const matches = Object.entries(variantData).filter(([, value]) => {
      if (!Array.isArray(value.options) || !Array.isArray(optionNames)) return false;
      return optionNames.every((optionName, index) =>
        !selectedOptions.has(optionName) || value.options[index] === selectedOptions.get(optionName)
      );
    });

    const hiddenId = wrapper?.querySelector('input[name="id"]')?.value || '';
    let variantId = '';
    if (selectedOptions.size > 0) {
      if (matches.length === 1) {
        variantId = matches[0][0];
      } else if (matches.length > 1 && matches.some(([id]) => id === hiddenId)) {
        variantId = hiddenId;
      }
    } else if (variantData[hiddenId]) {
      variantId = hiddenId;
    } else if (Object.keys(variantData).length === 1) {
      variantId = Object.keys(variantData)[0];
    }

    if (!variantId || !variantData[variantId]) {
      event.preventDefault();
      console.warn('ESSENTIA WhatsApp: la variante seleccionada aún no se pudo resolver.');
      return;
    }

    const variant = variantData[variantId];
    const productUrl = new URL(link.dataset.productUrl || window.location.pathname, window.location.origin);
    productUrl.searchParams.set('variant', variantId);
    const lines = [
      'Hola, necesito ayuda con este producto en ESSENTIA.',
      '',
      'Producto: ' + (link.dataset.productTitle || ''),
      'Presentación: ' + (variant.title || ''),
      'Precio: ' + (variant.price || ''),
      '',
      'Enlace: ' + productUrl.toString(),
      '',
      '¿Me ayudan a finalizar la compra?'
    ];
    link.href = 'https://wa.me/595991692682?text=' + encodeURIComponent(lines.join('\n'));
  });
  } catch(e) { console.error(e); }
})();

})();
